<template>
  <v-content>
    <v-row>
      <v-col>

      </v-col>
      <v-col>
        <RequestPasswordResetForm
          :reset="reset"
          v-on:usernameChanged="usernameChanged($event)"
          :resetRequested="resetRequested"
          :busy="busy"
        >
        </RequestPasswordResetForm>
      </v-col>
      <v-col>

      </v-col>
    </v-row>
  </v-content>
</template>

<script>
import RequestPasswordResetForm from '../components/RequestPasswordResetForm.vue';

export default {
  name: 'RequestPasswordReset',
  components: {
    RequestPasswordResetForm,
  },

  data() {
    return {
      username: '',
      resetRequested: false,
      busy: false,
    };
  },

  methods: {
    reset() {
      console.log(`...reset for ${this.username}`);

      const options = {
        method: 'POST',
        url: '/request/reset_user_password/v1',
        data: {
          username: this.username,
        },
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.resetRequested = true;
        })
        .catch((err) => {
          this.busy = false;
          console.log('request to reset password was rejected...');
        });
    },
    usernameChanged(value) {
      this.username = value;
    },
  },
};
</script>
